/**
 * 앞말의 받침에 맞춰 조사를 고른다 — 「매장 기본 편성」은, 「주말 특가」로.
 *
 * 이름은 사람이 짓는 값이라 한글로 끝나지 않을 수 있다(「Lobby A」, 「1층 2」). 그때는 받침을 알 수 없으니
 * 두 꼴을 함께 적는다 — 「Lobby A」은(는). 틀린 조사보다 낫다.
 */
type Pair = '은/는' | '이/가' | '을/를' | '과/와' | '으로/로';

const FALLBACK: Record<Pair, string> = {
  '은/는': '은(는)',
  '이/가': '이(가)',
  '을/를': '을(를)',
  '과/와': '과(와)',
  '으로/로': '(으)로',
};

export function josa(word: string, pair: Pair): string {
  const code = word.trim().slice(-1).charCodeAt(0);
  if (Number.isNaN(code) || code < 0xac00 || code > 0xd7a3) return FALLBACK[pair];
  const final = (code - 0xac00) % 28;
  const [withFinal, withoutFinal] = pair.split('/') as [string, string];
  // "로" 는 ㄹ 받침(8) 뒤에서도 "로" 다 — 「매장 운영시간」으로, 「스케줄」로.
  if (pair === '으로/로') return final === 0 || final === 8 ? withoutFinal : withFinal;
  return final === 0 ? withoutFinal : withFinal;
}
